/**
 * Euronics Ireland — Info Pages Shared JavaScript
 * Handles: mobile sidebar accordion, smooth scroll, active nav highlighting
 */
(function () {
  'use strict';

  /* ── Mobile Sidebar Accordion ── */
  document.querySelectorAll('.ip-sidebar').forEach(function (sidebar) {
    sidebar.addEventListener('click', function (e) {
      if (window.innerWidth > 768) return;
      // Only toggle if clicking the title area, not a link
      if (e.target.closest('a')) return;
      sidebar.classList.toggle('active');
    });
  });

  /* ── FAQ Accordion ── */
  document.querySelectorAll('.ip-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
    });
  });

  /* ── Smooth Scroll for Anchor Links ── */
  document.querySelectorAll('.ip-sidebar a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var offset = 90;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });

        // Close mobile sidebar after clicking
        if (window.innerWidth <= 768) {
          link.closest('.ip-sidebar').classList.remove('active');
        }
      }
    });
  });

  /* ── Active Nav Highlighting (IntersectionObserver) ── */
  var sections = document.querySelectorAll('.ip-section[id]');
  var navLinks = document.querySelectorAll('.ip-sidebar a[href^="#"]');

  if (sections.length && navLinks.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            navLinks.forEach(function (l) { l.classList.remove('active'); });
            var activeLink = document.querySelector('.ip-sidebar a[href="#' + entry.target.id + '"]');
            if (activeLink) activeLink.classList.add('active');
          }
        });
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
    );

    sections.forEach(function (s) { observer.observe(s); });
  }
})();
